import { parseVizConfig } from '../../utils';
import { getRunQueryChartConfig } from './runQueryTool/getRunQueryChartConfig';
export const getWebAiChartConfig = ({ vizConfig, metricQuery, maxQueryLimit, fieldsMap, overrideChartType, }) => {
    const parsedConfig = parseVizConfig(vizConfig, maxQueryLimit);
    if (!parsedConfig) {
        throw new Error('Invalid viz config');
    }
    return {
        type: parsedConfig.type,
        vizTool: parsedConfig.vizTool,
        metricQuery: parsedConfig.metricQuery,
        echartsConfig: getRunQueryChartConfig({
            queryTool: parsedConfig.vizTool,
            metricQuery,
            fieldsMap,
            overrideChartType,
        }),
    };
};
//# sourceMappingURL=getWebAiChartConfig.js.map